import { AutoThrow } from "@pdfking/errors"
import type { PdfiumAPI } from "@pdfking/pdfium"
import { Provision } from "@pdfking/pdfium"
import type { PDFReaderOptions, PDFSplitFunction, PDFSplitResult } from "@pdfking/renderer-api"
import type { Sequence } from "@pdfking/tfunc"
import { KeyTake } from "@pdfking/tfunc"

import { ReadPages } from "../internal/ReadPages"

const PDFSplitImpl = (
  api: PdfiumAPI,
  input: PDFReaderOptions,
  rangeFn?: (page_count: number) => Sequence<number>
): AsyncGenerator<PDFSplitResult> =>
  ReadPages<PDFSplitResult>(
    api,
    input.stream,
    input.size,
    rangeFn,
    async (handle, page_index) => {
      const { bytes, media, colors, transparency } = AutoThrow(
        await api.split_page(handle, page_index)
      )
      return {
        // The split's own bytes, handed on as they are: whoever stores them
        // decides what they become.
        stream: bytes,
        colors,
        transparency,
        ...media,
      }
    },
    // our merge output: every page is a pdf already, its media in the meta
    {
      chunk_size: input.chunk_size,
      section: (bytes, meta) => ({
        stream: bytes,
        ...KeyTake(meta, ["colors", "transparency", "bleed", "trim"]),
      }),
    }
  )

export const PDFSplit: PDFSplitFunction = (input, rangeFn) =>
  Provision(api => PDFSplitImpl(api, input, rangeFn))
